import axios from 'axios';

export default {
  async getDnBIdentity(identity) {
    return await axios({
        url: '/api/tenant/dnbidentity',
        method: 'post',
        data: identity
      }
    ).then(r => r.data);
  },
};
